import { render } from "./CampaignsOverview.vue?vue&type=template&id=799788a3&scoped=true"
import script from "./CampaignsOverview.vue?vue&type=script&lang=js"
export * from "./CampaignsOverview.vue?vue&type=script&lang=js"

import "./CampaignsOverview.vue?vue&type=style&index=0&id=799788a3&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799788a3"]])

export default __exports__